import type {NodeKey} from 'lexical';
import {DecoratorNode} from 'lexical';
import {Row} from '../../types';
import {Rows} from '../../constants';
import {createCell, createRow} from '../../commands';

export class TableNode extends DecoratorNode<React.ReactNode> {
    __rows: Rows;

    static getType(): string {
        return 'tablesheet';
    }

    static clone(node: TableNode): TableNode {
        return new TableNode(Array.from(node.__rows), node.__key);
    }

    constructor(rows?: Rows, key?: NodeKey) {
        super(key);
        this.__rows = rows || [];
    }
}

export function $createTableNodeWithDimensions(
    rowCount: number,
    columnCount: number,
    includeHeaders = true
): TableNode {
    const rows: Rows = [];
    for (let y = 0; y < columnCount; y++) {
        const row: Row = createRow();
        rows.push(row);
        for (let x = 0; x < rowCount; x++) {
            const isHeader = includeHeaders === true && (y === 0 || x === 0) ? 'header' : 'normal';
            const cell = createCell(isHeader);
            row.cells.push(cell);
        }
    }
    return new TableNode(rows);
}
